import { useContext } from "react";
import { KindOfOrder } from "../../../../types/enums";
import AddNoteButton from "../../../common/notes/components/AddNoteButton";
import { RefetchScope, WorkOrderContext } from "../context/WorkOrderContext";

export default function WorkOrderAddNoteButton() {

	const { order, refetchOrder } = useContext(WorkOrderContext);

	var companyIDs = [order.details.dealerCompanyID, order.details.assignedCompanyID];

	const params = {
		showNoteType: false,
		orderID: order.details.workOrderID,
		kindOfOrder: KindOfOrder.WorkOrder,
		companyIDs: companyIDs,
		emailSubject: order.details.woNumber,
		onNoteAdded: () => refetchOrder(RefetchScope.Notes)
	}

	return (
		<>
			<AddNoteButton
				caption="Add Work Order Note"
				params={params}
			/>
		</>
	)
}
